<template>
  <div>
    <GetChildrenInfo
      v-if="showChildrenInfo"
      :userRegister="user.customerRegNo"
      @hideChildrenInfoModal="close"
      @nextStep="showStep2"
    ></GetChildrenInfo>
    <GetTancode
      v-if="showTancode"
      :userRegister="user.customerRegNo"
      @hideTanCodeModal="close"
      @nextStep="showStep3"
    ></GetTancode>
    <ChooseChildren
      v-if="chooseFromChildren"
      :data="allInfo"
      @hideChildrenModal="close"
      @chooseChild="chooseChild"
    ></ChooseChildren>
    <AddChildren
      v-if="showAddKid"
      :childInfo="childInfo"
      :otherInfo="user"
      @hideChildrenModal="close"
    ></AddChildren>
  </div>
</template>

<script>
import AddChildren from "./AddChilrden";
import GetChildrenInfo from "./GetChildrenInfo.vue";
// import Success from "@/views/plugin/success";
import GetTancode from "./GetTancode.vue";
import ChooseChildren from "./ChooseChildren.vue";

export default {
  props: ["user"],
  data() {
    return {
      showTancode: false,
      showAddKid: false,
      successMessage: "",
      successModal: false,
      chooseFromChildren: false,
      otherInfo: {},
      childInfo: {},
    };
  },
  components: {
    AddChildren,
    // Success,
    GetTancode,
    ChooseChildren,
    GetChildrenInfo,
  },
  methods: {
    close() {
      this.$emit("hideChildrenModal");
    },
    showChildrenInfoModal() {
      this.showChildrenInfo = true;
    },
    hideChildrenModal() {
      this.showChildrenInfo = false;
      this.showAddKid = false;
      this.showTancode = false;
    },
    showStep2() {
      this.showChildrenInfo = false;
      this.showTancode = true;
    },
    showStep3(data) {
      this.showTancode = false;
      this.chooseFromChildren = true;
      this.allInfo = data;
    },
    chooseChild(data) {
      this.childInfo = data;
      this.chooseFromChildren = false;
      this.showAddKid = true;
    },
  },
  created() {
    this.showChildrenInfoModal();
  },
};
</script>
<style></style>
